import { showHttpErrorAlertCallout } from "@/shared/utils/show-http-error-alert-callout";
import { useGetRoleById } from "@/spz-api/roles/roles";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRoleForm } from "../hooks/use-role-form";
import type { RoleFormSchemaValues } from "./schemas/role-form.schema";

export const selectRoleFormViewModel = (
  roleId?: string,
  onSuccess?: () => void,
) => {
  const { t } = useTranslation();
  const roleForm = useRoleForm({
    roleId,
    onSuccess,
  });

  const {
    data: roleById,
    error,
    isLoading,
  } = useGetRoleById(roleId ?? "", {
    query: {
      enabled: Boolean(roleId),
    },
  });
  // biome-ignore lint/correctness/useExhaustiveDependencies: the add of roleForm.permissions dependency affects the initial values for edit role
  useEffect(() => {
    if (roleById) {
      const role = roleById.data;

      const initialValues: RoleFormSchemaValues = {
        name: role.name,
        description:
          typeof role.description === "string" ? role.description : undefined,
        permissionIds: role.permissionIds.map((item) => item.valueOf()),
        updatedAt: role.updatedAt,
      };
      roleForm.permissions.updateOptions(initialValues.permissionIds);

      roleForm.form.reset(initialValues);
    }
  }, [roleById, roleForm.form]);

  useEffect(() => {
    if (error) {
      showHttpErrorAlertCallout({
        error,
        defaultErrorMessage: t("role_by_id_error"),
      });
    }
  }, [error, t]);

  return {
    form: roleForm.form,
    onSubmit: roleForm.onSubmit,
    permissions: roleForm.permissions,
    isLoading,
  };
};
